export default __webpack_public_path__ + "static/media/searchbar.d1b7d74e.png";